module.exports = __webpack_public_path__ + "static/media/loaderSM.fd4d8b53.gif";